import { PostHog } from "posthog-js";
import { serviceContainer } from "services/serviceContainer";
import { hashString } from "utils/hashString";

// Analytics must never break the flow that triggered it (e.g. Web Crypto is unavailable on insecure contexts)
export const identifyPostHogUser = async (
  posthog: Pick<PostHog, "identify"> | undefined,
  email: string
): Promise<void> => {
  try {
    const hashedEmail = await hashString(email);
    posthog?.identify(hashedEmail, { email: hashedEmail });
  } catch (e) {
    serviceContainer.cradle.logger.warn("Failed to identify PostHog user", e);
  }
};
